import { t } from "@lingui/macro";

import { WhooshMutationError } from "@/utils/hooks/useMutationWithError";
import {
  InfoBanner,
  InfoBannerFailureIcon,
} from "@whoosh/design-system/src/components/display/InfoBanner";
import { VStack } from "@whoosh/design-system/src/components/primitive";

type Props = {
  errors: WhooshMutationError[];
  requestGroupCount: number;
};

export const AggregateRequestErrorBanner = ({
  errors,
  requestGroupCount,
}: Props) => {
  if (errors.length === 0) return null;

  return (
    <VStack gap={1} testID="aggregate-request-error-banner">
      {errors.map((error, index) => (
        <InfoBanner
          key={`${error.code}-${error.bookingIndex ?? "request"}-${index}`}
          leadingIcon={InfoBannerFailureIcon}
          colorTheme="ERROR"
          message={
            error.bookingIndex != null && requestGroupCount > 1
              ? t`Group ${error.bookingIndex + 1} of ${requestGroupCount}: ${
                  error.message ?? t`Unable to submit this request.`
                }`
              : error.message ?? t`Unable to submit this request.`
          }
          testID={`aggregate-request-error-${index}`}
        />
      ))}
    </VStack>
  );
};
